import styled from 'styled-components';
import React from 'react';

const StyledLabel = styled.label`
    display: inline-flex;
    width: 30%;
    justify-content: center;
    font-size: 1.6em;

    vertical-align: center;
    text-align: center;
`;

const InputLabelWide = ({ text = '' }) => <StyledLabel>{text}</StyledLabel>;

export default InputLabelWide;
